/** Errores conocidos del agente local → copy para el dueño (sin JSON ni status). */

export function formatPrintAgentHttpError(status: number, body: string): string {
  const trimmed = body.trim();
  if (trimmed.includes('no_printer_configured')) {
    return 'No hay impresora térmica elegida. Elegila en Tickets de venta.';
  }
  if (trimmed) {
    try {
      const parsed = JSON.parse(trimmed) as { error?: unknown };
      if (typeof parsed.error === 'string' && parsed.error.trim()) {
        return `El programa de impresión no pudo imprimir (${parsed.error.trim()}).`;
      }
    } catch {
      /* body no es JSON */
    }
  }
  return trimmed
    ? `El programa de impresión respondió ${status}.`
    : `El programa de impresión respondió ${status}. ¿Está abierto en esta computadora?`;
}

export function formatPrintFallbackWarning(reason: string): string {
  if (reason.includes('impresora térmica elegida') || reason.includes('no_printer_configured')) {
    return 'No hay impresora térmica elegida. El ticket salió por vista previa.';
  }
  return `Impresión directa falló (${reason}); salió por vista previa.`;
}
